import Cookie from "./modules/cookie";
import Faq from "./modules/faq";
import FaqSearch from "./modules/faq-search";
import Forms from "./modules/forms";
import Frontify from "./modules/frontify";
import HeaderSearch from "./modules/header-search";
import KeyMetricsPage from "./modules/key-metrics-page";
import LandingpageHeroMedia from "./modules/landing-page-hero-media";
import ListingPage from "./modules/listing-page";
import Menu from "./modules/menu";
import ModalWindow from "./modules/modal-window";
import ResponsiveTables from "./modules/responsive-tables";
import Search from "./modules/search-page";
import Splash from "./modules/splash";
import StartPageParallax from "./modules/start-page-hero-parallax";
import Timeline from "./modules/timeline";
import VideoPlayer from "./modules/video-player";
import GeoLocation from "./modules/geolocation";
import GuidedFormPage from "./modules/guided-form-page";
import AnimatedVideoIcons from "./modules/animated-video-icons";
import AnimatedShape from "./modules/animated-shapes";

Faq.init();
Menu.init();
Splash.init();
ResponsiveTables.init();
Cookie.init();
Timeline.init();
FaqSearch.init();
ListingPage.init();
KeyMetricsPage.init();
ModalWindow.init();
Search.init();
VideoPlayer.init();
StartPageParallax.init();
LandingpageHeroMedia.init();
Forms.init();
Frontify.init();
HeaderSearch.init();
GeoLocation.init();
GuidedFormPage.init();
AnimatedVideoIcons.init();
AnimatedShape.init();
